import { create } from 'zustand';

// Steuert den mobilen Off-Canvas-Navigations-Drawer (< lg). Bewusst als Store
// und nicht als lokaler useState in AppShell, damit die Nav-Links den Drawer
// beim Navigieren schliessen koennen, ohne den State durch mehrere Ebenen zu
// faedeln. Nicht persistiert — der Drawer startet immer geschlossen.

interface NavDrawerState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useNavDrawerStore = create<NavDrawerState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
}));
